module.exports = __webpack_public_path__ + "static/media/kiwi.4ee36f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/kiwi.png
// module id = 53
// module chunks = 0